// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__2jNRA","title":"AfterImages45_title__1oCqK","images":"AfterImages45_images__1cscH"};